import React from "react";
import { GlobalAlerts } from "@/features/betslip/components/GlobalAlerts";
import { UnauthorizedAlerts } from "@/features/betslip/components/UnauthorizedAlerts";

import * as styles from "@/features/betslip/components/PinnedAlerts.module.scss";

// Slip-level alerts (transport/timeout errors, account state) pinned in a band
// between the tab bar and the scrolling body, so the message and its CTA stay
// visible however far the slip is scrolled. Collapses to zero height when both
// alerts are absent.
export const PinnedAlerts = () => (
  <div className={styles.band}>
    <GlobalAlerts />
    <UnauthorizedAlerts />
  </div>
);
